import { Component } from '@angular/core';

@Component({
  selector: 'app-update-familyhistory',
  templateUrl: './update-familyhistory.component.html',
  styleUrls: ['./update-familyhistory.component.css']
})
export class UpdateFamilyhistoryComponent {

}
